import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgScan({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 14a1 1 0 01.993.883L21 15v3a3 3 0 01-2.824 2.995L18 21h-3a1 1 0 01-.117-1.993L15 19h3a1 1 0 00.993-.883L19 18v-3a1 1 0 011-1zM4 14a1 1 0 01.993.883L5 15v3a1 1 0 00.883.993L6 19h3a1 1 0 01.117 1.993L9 21H6a3 3 0 01-2.995-2.824L3 18v-3a1 1 0 011-1zm12-3a1 1 0 110 2H8a1 1 0 110-2h8zm2-8a3 3 0 012.995 2.824L21 6v3a1 1 0 01-1.993.117L19 9V6a1 1 0 00-.883-.993L18 5h-3a1 1 0 01-.117-1.993L15 3h3zM9 3a1 1 0 01.117 1.993L9 5H6a1 1 0 00-.993.883L5 6v3a1 1 0 01-1.993.117L3 9V6a3 3 0 012.824-2.995L6 3h3z"
        fill={color}
      />
    </svg>
  )
}

export default SvgScan
